import * as React from 'react';
import PropTypes from 'prop-types';
import {Dimmer, Icon, Image, Segment, Card as SemanticCard, Button, Loader} from "semantic-ui-react";
import {Subbar, Title, PageHeader} from "ah-tools";
import ServiceForm from "./ServiceForm";
import {translate} from "react-i18next";
import {ROUTE_SERVICE} from "../routes";
import {ExtendedPlaceholder} from "./Placeholder";
import isEmpty from 'lodash/isEmpty';
import {Card, CardHeader, CardText, Checkbox, Divider} from "material-ui";
import {COLOR_PRIMARY, IMAGE_URL} from "../misc/vars";
import naImage from '../images/not-available.jpg';
import cn from "classnames";
import VirtualList from 'react-tiny-virtual-list';
import WorkTimeController from "../containers/WorkTimeController";
import {PriceInfo} from "./WorkTime";
import {sort} from "ith-sort";
import {IconButton} from "../extensions";

const EXPANDED_BASIC = 1;
const EXPANDED_LOGO = 2;
const EXPANDED_KFZ = 3;

class ServiceEdit extends React.Component {
	static propTypes = {
		isLoading: PropTypes.bool,
		onUpdate: PropTypes.func.isRequired,
		push: PropTypes.func,
		service: PropTypes.object.isRequired,
		isUploading: PropTypes.bool,
		onUploadLogo: PropTypes.func.isRequired,
		onDeleteLogo: PropTypes.func,
		kfz_list: PropTypes.array,
		service_list: PropTypes.object
	};
	static defaultProps = {
		isLoading: false,
		onUpdate: () => alert('onUpdate() is not implemented'),
		onUploadLogo: () => alert('onUploadLogo() is not implemented'),
		service: {},
		isUploading: false,
		kfz_list: [],
		service_list: {}
	};
	state = {
		logo: null,
		preview: null,
		origin_logo: null,
		expanded: 0,
		showKfz: null,
		showEmpty: false
	};
	
	setLogo = logo => {
		if ( logo ) {
			logo = `${IMAGE_URL}${logo.ident}.${logo.origin_extension}?${logo.updated_at}`;
		}
		this.setState({preview: logo, origin_logo: logo, logo: null});
	};
	
	handleLogoSelection = ({target: {files}}) => {
		const logo = files && files.length ? files[0] : null;
		this.setState({logo});
		if ( logo && 'FileReader' in window ) {
			const reader = new FileReader();
			reader.onload = ({target:{result: preview}}) => this.setState({preview});
			reader.readAsDataURL(logo);
		} else {
			this.setState({preview: this.state.origin_logo});
		}
	};
	
	expandTo = (value) => this.setState(state => ({
		expanded: state.expanded === value ? 0 : value
	}));
	
	setKfz = (kfz = null) => this.setState(state => ({
		showKfz: kfz ? (state.showKfz && state.showKfz.kfz_id === kfz.kfz_id ? null : kfz) : kfz
	}));
	
	getKfz2Service = (service_id, kfz_id, obj=true) => {
		const {service_list} = this.props;
		return service_list[kfz_id] || (obj ? {service_id, kfz_id} : null);
	};
	
	componentDidMount() {
		const {service} = this.props;
		if ( service ) {
			this.setLogo(service.logo);
		}
	}
	
	componentWillReceiveProps({service}) {
		if ( service ) {
			this.setLogo(service.logo);
		}
	}
	
	
	render() {
		const {isLoading, onUpdate, push, service, isUpdating, isUploading, onUploadLogo, onDeleteLogo, kfz_list, service_list} = this.props;
		const {logo, preview, expanded, showKfz, showEmpty} = this.state;
		// const _extendedKfzList = [...kfz_list].map(k => processData(k)(k => k.selected = Number(showKfz && showKfz.kfz_id === k.kfz_id)));//.sort(sortNumDesc(k => k.selected));
		// const extendedKfzList = sort(_extendedKfzList, [ k => k.selected ? 0 : 1]);
		const filteredList = kfz_list.filter(kfz => {
			return showEmpty ? !service_list[kfz.kfz_id] : true;
		}).sort(sort()(kfz => kfz.name));
		const assignedCount = kfz_list.length - filteredList.length;
		return (
			<Segment basic>
				<PageHeader>
					<Subbar>
						{push &&
							<IconButton onClick={() => push(ROUTE_SERVICE)}>
								<Icon name={'chevron left'} size={'large'}/>
							</IconButton>
						}
						<Title loading={isLoading}>{service.title ? `Service '${service.title}' bearbeiten` : 'Serviceleistung bearbeiten'}</Title>
					</Subbar>
				</PageHeader>
				<ExtendedPlaceholder visible={isEmpty(service)} repeat={3}>
					<Card expandable expanded={expanded === EXPANDED_BASIC} onExpandChange={(_, value) => this.expandTo(EXPANDED_BASIC)} className={cn('ith-house-card', {active: expanded === EXPANDED_BASIC})}>
						<CardHeader actAsExpander showExpandableButton className={'ith-card-title'}>
							<Title as={'h3'}>Basisdaten</Title>
						</CardHeader>
						<CardText expandable>
							<ServiceForm
								service={service}
								isSaving={isUpdating}
								onSave={onUpdate}
								showActive
							/>
						</CardText>
					</Card>
					<Card expandable expanded={expanded === EXPANDED_LOGO} onExpandChange={(_, value) => this.expandTo(EXPANDED_LOGO)} className={cn('ith-house-card', {active: expanded === EXPANDED_LOGO})}>
						<CardHeader actAsExpander showExpandableButton className={'ith-card-title'}>
							<Title as={'h3'}>Logo</Title>
						</CardHeader>
						<CardText expandable>
							<input
								style={{position: 'absolute', top: -9999999, left: -999999999, width: 1, height: 1, overflow: 'hidden'}}
								type="file"
								id={'logo-upload'}
								accept={'image/png,image/jpg,image/jpeg'}
								onChange={this.handleLogoSelection}/>
							<Subbar>
								<SemanticCard style={{textAlign: 'center'}}>
									<Dimmer active={isUploading}><Loader size={'large'} style={{color: COLOR_PRIMARY}} className={'blue-loader'}><strong>Lade Logo hoch</strong></Loader></Dimmer>
									<Subbar align={Subbar.ALIGN_CENTER} style={{position: 'relative'}}>
										<Image src={preview ? preview : naImage} alt={'Logo'} size={'small'}/>
										{onDeleteLogo && service.logo_id && <IconButton  onClick={() => onDeleteLogo(service)} style={{zIndex: 2, position: 'absolute', top: 0, right: 0, background: 'rgba(0,0,150,0.1)', borderRadius: '50%', borderTopRightRadius: '.28571429rem'}}><Icon name={isUpdating ? 'spinner' : 'trash'} loading={isUpdating}/></IconButton>}
									</Subbar>
									<SemanticCard.Content style={{position: 'relative'}}>
										<SemanticCard.Header>Logo-Upload</SemanticCard.Header>
										{logo && <SemanticCard.Meta>{logo.name}</SemanticCard.Meta>}
									</SemanticCard.Content>
									<SemanticCard.Content extra>
										<label htmlFor="logo-upload" className={'ui button'} role={'button'}><Icon name={'image'}/> wählen</label>
										{logo && <Button style={{marginLeft: 15}} positive inverted icon onClick={() => onUploadLogo(service, logo)}><Icon name={'upload'}/></Button>}
									</SemanticCard.Content>
								</SemanticCard>
							</Subbar>
						</CardText>
					</Card>
					<Card expandable expanded={expanded === EXPANDED_KFZ} onExpandChange={() => this.expandTo(EXPANDED_KFZ)} className={cn('ith-house-card', {active: expanded === EXPANDED_KFZ})}>
						<CardHeader actAsExpander showExpandableButton className={'ith-card-title'} >
							<Title as={'h3'}>Kfz-Marken (Arbeitszeit und Preise)</Title>
						</CardHeader>
						<CardText expandable>
							<Subbar>
								<div>
									<Checkbox label={'Zugewiesene ausblenden ' + (assignedCount ? `(${assignedCount})` : '')} checked={showEmpty} onCheck={(_, value) => this.setState({showEmpty: value})} style={{marginBottom: 10}}/>
									<VirtualList
										width={400}
										height={300}
										itemCount={filteredList.length}
										itemSize={40}
										renderItem={({index, style}) => {
											const kfz = filteredList[index];
											const rel = this.getKfz2Service(service.service_id, kfz.kfz_id, false);
											return (
												<div onClick={() => this.setKfz(kfz)} key={kfz.kfz_id} style={{
													...style,
													display: 'flex',
													flexDirection: 'column',
													justifyContent: 'flex-end',
													backgroundColor: showKfz && showKfz.kfz_id === kfz.kfz_id ? COLOR_PRIMARY : null
												}}>
													<Subbar align={Subbar.ALIGN_BETWEEN} style={{margin: 'auto 10px'}}>
														{kfz.name}
														{rel && <PriceInfo time={rel.hours_of_work} price={rel.price}/>}
													</Subbar>
													<Divider/>
												</div>
											);
										}}
									/>
								</div>
								<div style={{marginLeft: 25, flexGrow: 100}}>
									<WorkTimeController
										priceRequired
										open={!!showKfz}
										title={showKfz ? showKfz.name : 'No kfz'}
										kfz2service={showKfz ? this.getKfz2Service(service.service_id, showKfz.kfz_id) : {}}
									/>
								</div>
							</Subbar>
						</CardText>
					</Card>
				</ExtendedPlaceholder>
				{/*<Dialog
					open={!!showKfz}
					className={'full-screen-dialog'}
					onRequestClose={() => this.setState({showKfz: null})}
				>
					<PageHeader align={Subbar.ALIGN_BETWEEN} style={{paddingLeft: 20}}>
						<Title>{showKfz && showKfz.name}</Title>
						<Subbar>
							<IconButton onClick={() => this.setState({showKfz: null})}><Icon name={'close'} size={'large'}/></IconButton>
						</Subbar>
					</PageHeader>
					<div className={'full-screen-dialog-body'}>
						<div style={{width: 500, height: 1802, background: 'red'}}/>
					</div>
				</Dialog>*/}
			</Segment>
		);
	}
}

export default translate()(ServiceEdit);


// WEBPACK FOOTER //
// ./src/components/ServiceEdit.js